import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Sidebar from "./Sidebar";
import Header from "./Header";
import GlobalNotifications from "../components/GlobalNotifications";

// Componente semplificato di loading
const LoadingSpinner = () => (
  <div className="flex justify-center items-center min-h-screen bg-gray-50 dark:bg-gray-900">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
  </div>
);

export default function ProtectedLayout() {
  const { isAuthenticated, loading, initialCheckDone, user } = useAuth();
  const location = useLocation();

  // Debug (mantenuto per verifica)
  // useEffect(() => {
  //   console.log("ProtectedLayout: Auth state", {
  //     isAuthenticated,
  //     loading,
  //     initialCheckDone: initialCheckDone ?? false, // Usa ?? per default
  //     pathname: location.pathname
  //   });
  // }, [isAuthenticated, loading, initialCheckDone, location]);

  // Mostra lo spinner se l'autenticazione è in corso o il check iniziale non è completo
  // Usa ?? per gestire il caso in cui initialCheckDone potrebbe essere undefined inizialmente
  if (loading || !(initialCheckDone ?? false)) {
    // console.log("ProtectedLayout: Rendering LoadingSpinner");
    return <LoadingSpinner />;
  }

  // Se non autenticato DOPO che il check iniziale è completo, redirect al login
  if (!isAuthenticated) {
    // console.log("ProtectedLayout: Not authenticated, redirecting to login.", { from: location });
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Autenticato: rendi Sidebar, Header, contenuto principale e notifiche globali
  // console.log("ProtectedLayout: Authenticated, rendering Sidebar and Outlet for user:", user?.username);
  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden ml-16">
        <Header />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 dark:bg-gray-900 p-6 ml-4 pt-20"> {/* AGGIUNTO pt-20 per header fisso + CORRETTO bg tema scuro */}
          <Outlet />
        </main>
      </div>
      {/* 🔔 Notifiche Globali */}
      <GlobalNotifications isVisible={true} />
    </div>
  );
}